import React from "react";
import styled from "styled-components";

import {
  AdminButton,
} from "../action_engine";

const AdminPaginationRoot = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1rem;
`;

const AdminPaginationLabel = styled.span`
  color: rgba(247, 247, 247, 0.72);
  font-size: 0.9rem;
`;

export default function AdminPagination({
  previousDisabled = false,
  nextDisabled = false,
  onPrevious,
  onNext,
  label,
  previousLabel = "Page précédente",
  nextLabel = "Page suivante",
  ariaLabel = "Pagination",
  buttonVariant = "secondary",
}) {
  return (
    <AdminPaginationRoot
      aria-label={ariaLabel}
    >
      <AdminButton
        type="button"
        variant={buttonVariant}
        disabled={previousDisabled}
        onClick={onPrevious}
      >
        {previousLabel}
      </AdminButton>

      {label ? (
        <AdminPaginationLabel>
          {label}
        </AdminPaginationLabel>
      ) : null}

      <AdminButton
        type="button"
        variant={buttonVariant}
        disabled={nextDisabled}
        onClick={onNext}
      >
        {nextLabel}
      </AdminButton>
    </AdminPaginationRoot>
  );
}
